module.exports = __webpack_public_path__ + "static/media/i54.276f1192.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/i54.svg
// module id = 196
// module chunks = 12